import { defineStore } from "pinia";
import { _GettersTree, _ActionsTree, StoreDefinition } from "pinia";
import type { TVInRoom, TVPlaybackStatus } from "@/@types/connection/tvs";

interface StoreState {
  tvs: TVInRoom[];
  activeTV: string;
  /** Прогресс воспроизведения на выбранном ТВ (приходит по ws каждую секунду) */
  tvPlayback: TVPlaybackStatus | null;
  /** Токен запроса на открытие офканваса с пультом magic_remote */
  remoteOpenToken: number;
}

const state = (): StoreState => ({
  tvs: [],
  activeTV: localStorage.getItem("connect-active-tv") || "",
  tvPlayback: null,
  remoteOpenToken: 0,
});

const getters = {
  getActiveTV: (state: StoreState): string => {
    return state.activeTV;
  },
  getTVs: (state: StoreState): TVInRoom[] => {
    return state.tvs;
  },
  getActiveTVObj: (state: StoreState): TVInRoom | null => {
    const tv = state.tvs.find((el: TVInRoom) => el._id === state.activeTV);
    return tv ? tv : null;
  },
  getTvPlayback: (state: StoreState): TVPlaybackStatus | null => {
    return state.tvPlayback;
  },
  getRemoteOpenToken: (state: StoreState): number => {
    return state.remoteOpenToken;
  },
};

interface CartActions {
  setactiveTV(id: string): void;
  setTVs(tvs: TVInRoom[]): void;
  setTvPlayback(playback: TVPlaybackStatus | null): void;
  requestRemoteOpen(): void;
}
const actions = {
  setactiveTV(this: CartActions & StoreState, id: string) {
    this.activeTV = id;
    localStorage.setItem("connect-active-tv", id);
  },
  setTVs(this: CartActions & StoreState, tvs: TVInRoom[]) {
    this.tvs = tvs;
  },
  setTvPlayback(this: CartActions & StoreState, playback: TVPlaybackStatus | null) {
    this.tvPlayback = playback;
  },
  requestRemoteOpen(this: CartActions & StoreState) {
    this.remoteOpenToken += 1;
  },
};

export const useTVConnect: StoreDefinition<
  string,
  StoreState,
  _GettersTree<StoreState>,
  _ActionsTree
> = defineStore<string, StoreState>("tvconnect", {
  state,
  getters,
  actions,
});

export type ICartStore = ReturnType<typeof useTVConnect>;
